import React from "react";

export function createStore<T>(initialState: T) {
  let state = initialState;
  const getState = () => state;
  const listeners = new Set<Function>();
  const setState = (fn: Function) => {
    state = fn(state);
    listeners.forEach(l => l());
  };
  const subscribe = (listener: Function) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  };
  const setStoreState = (nextState: Partial<T>) => {
    setState(state => ({ ...state, ...nextState }));
  };
  return { getState, setStoreState, subscribe };
}

const Store = createStore({
  // count: 1,
  /** 下拉刷新是否启用，默认开启。
   * 可根据页面链接来禁用，如
   *
  ```ts
      !["/video", "/live"].some((p) =>location.pathname.includes(p))
  ```
   */
  pullToRefreshEnabled: true,
});

export default Store;

export const useStore = (): ReturnType<typeof Store.getState> & typeof Store => {
  const storeState = React.useSyncExternalStore(Store.subscribe, () => Store.getState());
  return React.useMemo(() => ({ ...storeState, ...Store }), [storeState]);
};

/**
 * 如何使用
 * const {count, setStoreState} = useStore();
 * <button onClick={() => setStoteState({count: count + 1})}>{count}</button>
 * @see https://stackblitz.com/edit/react-ts-fxbvmw?file=App.tsx
 */
